import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";

export class DefaultTextBehavior implements IHisInfoItemBehavior {
  constructor(private key: string) {}

  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const values =  hisInfoItems.filter(x => x.name === this.key).map(x => x.value);
    return new HisInformationTextValue(this.key, values);
  }
}
